<p
  #inputElement
  *ngIf="(editionMode$ | async) === EditionMode.WRITE_ENABLED && !disabled"
  [style.color]="textColor"
  [style.--fontSize]="fontSize"
  class="mobile-input bg-white"
  type="text"
  txtbAutofocusElem
  [focusDelay]="200"
  [blockAutofocus]="false"
  [spellcheck]="false"
  [textContent]="content"
  [contentEditable]="true"
  (input)="onInput($event)"
  (keypress)="onInputKeypress($event)"
  (focusin)="onTextFieldFocus(inputElement)"
  (focusout)="onTextFieldBlur()"
></p>
<div class="textbox" txtbClickOutside (clickOutside)="onClickOutside()">
  <div
    [class.is-locked-center]="(editionMode$ | async) === EditionMode.WRITE_ENABLED"
    class="textbox-wrapper"
    tabindex="-1"
    (cdkDragStarted)="onDragStart()"
    (cdkDragMoved)="onDragMove($event)"
    (cdkDragEnded)="onDragEnd()"
    [cdkDragBoundary]="'.notes-boundary'"
    cdkDrag
    #dragContainer
  >
    <div #innerWrapper
         [attr.tabindex]="disabled ? -1 : 1"
         class="textbook-inner-wrapper"
         (focusin)="onWrapperFocus()"
    >
      <p
        [style.color]="textColor"
        [style.--fontSize]="fontSize"
        [attr.tabindex]="(editionMode$ | async) === EditionMode.NONE || disabled ? -1 : 1"
        [attr.role]="'input'"
        class="textbox-input"
        [contentEditable]="(editionMode$ | async) === EditionMode.MOVE_ENABLED && !disabled"
        [class.is-disabled]="(editionMode$ | async) === EditionMode.NONE || disabled"
        [class.is-hidden]="(editionMode$ | async) === EditionMode.WRITE_ENABLED"
        [textContent]="content"
        (keydown)="$event.preventDefault()"
        (click)="enableWriteMode($event)"
        #textContentElement
      ></p>
      <ul [style.--tooltipLeft]="tooltipLeft"
          class="tooltip"
          [class.is-hidden]="(editionMode$ | async) !== EditionMode.MOVE_ENABLED"
          cdkDragHandle>
        <li>
          <button type="button" (click)="remove($event)">
            <txtb-icons type="trashbin" class="trashbin-icon"></txtb-icons>
          </button>
        </li>
        <li>
          <button type="button" class="change-font-size" (click)="changeFontSize(1)">
            <txtb-icons type="fontBigger" class="font-bigger-icon"></txtb-icons>
          </button>
        </li>
        <li>
          <button type="button" class="change-font-size" (click)="changeFontSize(-1)">
            <txtb-icons type="fontSmaller" class="font-smaller-icon"></txtb-icons>
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
